import compareVersions from 'compare-versions';
// @ts-ignore
export const getUserAgent = () => navigator.wxuserAgent || navigator.userAgent;

/**
 * 获取OS信息
 */
export const getOSInfoObj = (): { type: 'iphone' | 'android' | 'none', version: string } => {
  let pattern = /(iPhone OS |iPad; CPU OS )([\d_]+)/i;
  let wc = getUserAgent().match(pattern);
  if (wc) return { type: 'iphone', version: wc[2].replace(/_/g, '.') };
  pattern = /Android ([\d.]+)/i;
  wc = getUserAgent().match(pattern);
  if (wc) return { type: 'android', version: wc[1] };
  return { type: 'none', version: '0.0.0' };
};

/** 获取系统信息文本 */
export const getOSInfoText = () => {
  const os = getOSInfoObj();
  return `${os.type} ${os.version}`;
};

/**
 * 获取微信版本
 */
export const getWeixinVer = (): string => {
  // ...MicroMessenger/7.0.1380(0x2700003D)...获取(0x....)
  let pattern = /MicroMessenger\/[\d.]+\((.*)\)/i;
  let wc: Array<string> | null = getUserAgent().match(pattern);
  if (!wc) {
    pattern = /MicroMessenger\/([\d.]+)/i;
    wc = getUserAgent().match(pattern);
    if (wc) return wc[1];
  }
  if (!wc) return '0.0.0';
  const version = wc[1].slice(3);
  if (!version) {
    return '0.0.0';
  }
  const result: number[] = [];
  result.push(parseInt(version.slice(0, 1), 16) || 0);
  result.push(parseInt(version.slice(1, 3), 16) || 0);
  result.push(parseInt(version.slice(3, 5), 16) || 0);
  return result.join('.');
};

/**
 * 比较版本1和版本2的高低, 0 相等，-1 v1 < v2， 1 v1 > v2
 * @param v1 版本1(格式类似7.0.12)
 * @param v2 版本2(格式类似7.0.12)
 */
export const verCompare = (v1: string, v2: string) => {
  // 兜底处理，如果没有传v1或v2，则默认是0
  const formatV1 = v1 || '0';
  const formatV2 = v2 || '0';
  return compareVersions(formatV1, formatV2);
};

/**
 * 比较微信版本大于等于ver
 * @param ver 比较的版本
 */
export const isWexinVerLargeOrEqualThan = (ver: string) => {
  const curVer = getWeixinVer();
  return verCompare(curVer, ver) > -1;
};


/**
 * 判断安卓、ios的版本是否大于等于指定版本
 * 如果对android系统没版本要求，则传入如 android: '0.0.0'
 * @param minVer 两个系统的最低版本
 */
export const isOSVerLargeOrEqualThan = (minVer: {
  android: string;
  iphone: string;
}) => {
  const { type, version } = getOSInfoObj();
  const ver = minVer[type];
  if (!ver) {
    // 这里处理了type为none，或者没有传入某类最低版本的场景
    return false;
  }
  return verCompare(version, ver) > -1;
};

/**
 * 判断在所有的系统下最小要求支持的微信版本
 * @param minVersions 微信最小版本号（需要指定每个系统下的版本号，如：iphone: "8.0.20"，android:"8.0.21",如果对版本没要求，可传入0.0.0）
 * @returns
 */
export const isAllWxVersionSupported = (minVersions: {iphone: string, android: string}) => {
  const os = getOSInfoObj();
  const version = (os.type === 'iphone') ? minVersions.iphone : minVersions.android;
  return isWexinVerLargeOrEqualThan(version);
};

/** 判断是否在微信浏览器内 */
export const isInWeixin = () => /MicroMessenger/i.test(getUserAgent());

/**
 * 判断是否在小程序内
 */
// @ts-ignore
export const isInMiniProgram = () => /miniprogram/i.test(getUserAgent()) || window.__wxjs_environment === 'miniprogram';

/**
 * H5 被小程序内嵌时，获取宿主小程序appId
 */
export const getMiniProgramAppId = () => {
  const ua = getUserAgent();
  const pattern = /miniProgram\/(\w+)/;
  const result = pattern.exec(ua);
  if (result?.[1]) {
    return result[1];
  }
  return '';
};
